import axios from "axios"
import { Message } from 'element-ui';
// localStorage.setItem("token","Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpYXQiOjE2MzMxNjA3ODIsIm5iZiI6MTYzMzE2MDc4MiwianRpIjoiNTU5MDg3ZTAtMWY2Zi00YzcxLTk1ZGEtYWY4NjkzODRlNjc3IiwiaWRlbnRpdHkiOiJ0ZXN0IiwiZnJlc2giOmZhbHNlLCJ0eXBlIjoiYWNjZXNzIn0.iXUg6u6P74wBWUILkEPuc9DzlxAn1U1oQhY9On0xCNQ")
import router from "../router"

const service=axios.create({
    baseURL: process.env.Base_url,
    timeout: 60000
})
service.interceptors.request.use(config=>{
    let token=localStorage.getItem("token")
    console.log("token",token)
    // config.url="http://129.204.62.189:5000"+config['url']
    if(token&&(config.url.indexOf("login")<0)){
        config.headers.Authorization ="Bearer "+token
        console.log(config);
    }else{
        if(config.url.indexOf("login")<0){
            Message.error("请先登录账号")
            router.replace({
                path: '/login',
                query: {
                  redirect: router.currentRoute.fullPath
                }
              })
        }
    }
    // else{
    //     Message.error("token不存在")
    //     return Promise.reject("token无效")

    // }
    return config
})

service.interceptors.response.use(res=>{
    console.log(res,"res");
    if(res.data&&res.data.status=="200"&&res.data.success){
        return Promise.resolve(res.data)
    }else{
        if(res.status=="401"||res.status=="422"||res.data.status=="401"){
            Message.error("登录过期，请重新登录！")
            router.replace({
                path: '/login',
                query: {
                  redirect: router.currentRoute.fullPath
                }
              })
        }else{
            res.data&&res.data.msg&&(Message.error(res.data.msg))
        }
        return Promise.reject(res.data.msg)
    }
},
    error => {
        if (error.response) {
          switch (error.response.status) {
            case 401:
              // 返回 401 清除token信息并跳转到登录页面
              Message.error("登录失效，请重新登录！")
              router.replace({
                path: '/login',
               
              })
            break;
            case 422:
                // 返回 401 清除token信息并跳转到登录页面
                Message.error("登录失效，请重新登录！")
                router.replace({
                  path: '/login'
                })
            break;
            
          }
        }
}

)

export default service


// WEBPACK FOOTER //
// ./src/utils/request.js